import React, { useContext } from 'react';
import { layoutContext } from 'context/layout-provider';
import s from '../stats.module.scss';

function BarsChart({ data, labels }) {
  const marginBot = 28;
  const height = 160;
  const rectwidth = 25;
  const width = 450;
  const marginBetweenRects = 3;
  const marginBetweenPairs =
    (width - 2 * rectwidth * data.length) / data.length;
  const pairSize = 2 * rectwidth + marginBetweenPairs;
  const maleColor = '#54C6E0';
  const femaleColor = '#D85A8F';
  const emptyColor = '#EDEDED';

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      className={s.ageChart}
    >
      {data.map(([male, female], i) => (
        <g key={`pair-${labels[i]}`}>
          <g>
            <text
              x={pairSize * i + rectwidth / 3}
              y={height - marginBot - male * 2 - 10}
              fill="black"
              style={{ fontSize: '9px', fontWeight: '500' }}
            >
              {`${male}%`}
            </text>
            <rect
              width={rectwidth}
              height={(male > 0 ? male : 1) * 2}
              x={(rectwidth * 2 + marginBetweenPairs) * i}
              y={height - marginBot - (male > 0 ? male : 1) * 2}
              style={{ fill: male ? maleColor : emptyColor }}
              rx="3"
            />
          </g>
          <g>
            <text
              x={pairSize * i + rectwidth * 1.3 + marginBetweenRects}
              y={height - marginBot - female * 2 - 10}
              fill="black"
              style={{ fontSize: '9px', fontWeight: '500' }}
            >
              {`${female}% `}
            </text>
            <rect
              width={rectwidth}
              height={(female > 0 ? female : 1) * 2}
              x={
                (rectwidth * 2 + marginBetweenPairs) * i +
                rectwidth +
                marginBetweenRects
              }
              y={height - marginBot - (female > 0 ? female : 1) * 2}
              style={{ fill: female ? femaleColor : emptyColor }}
              rx="3"
            />
          </g>
          <text
            x={pairSize * i + rectwidth / 3}
            y={height - 10}
            fill="black"
            style={{ fontSize: '15px', fontWeight: '500' }}
          >
            {labels[i]}
          </text>
        </g>
      ))}
    </svg>
  );
}

export default BarsChart;
